/* src/app/dynamic-forms/dynamic-forms.component.scss */
:host {
  font-weight: 400;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 20px 20px;
}
@media (max-width: 550px) {
  app-dynamic-forms {
    padding-left: 15px;
    padding-right: 15px;
  }
}
::ng-deep .progress-linear {
  position: relative !important;
}
::ng-deep .progress-linear .container {
  max-width: 100% !important;
}
.formview {
  height: 100%;
}
table {
  width: 100%;
}
.mat-mdc-form-field {
  font-size: 80%;
  width: 100%;
}
td,
th {
  width: 25%;
}
::ng-deep .ngx-datatable .datatable-icon-skip:before {
  content: "q";
}
::ng-deep .ngx-datatable .sortable .sort-btn:before {
  font-family: data-table;
}
::ng-deep .ngx-datatable .sortable .sort-btn.datatable-icon-down:before {
  content: "f";
}
::ng-deep .ngx-datatable .sortable .sort-btn.datatable-icon-up:before {
  content: "e";
}
:host ::ng-deep .datatable-body-row.active .datatable-row-group {
  background-color: lightgray !important;
}
.icon {
  position: absolute;
}
.datatable-icon-down {
  top: 0px;
}
.datatable-icon-up {
  top: 40px;
}
.dragFromLeft .icon {
  left: -13px;
}
.server-scrolling {
  height: calc(75vh - 100px);
}
.server-scrolling .progress-linear {
  position: fixed !important;
  bottom: 0px;
}
.visibility {
  display: hidden;
}
.loading-indicator {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.loading-indicator::before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
}
.toolbar {
  height: fit-content;
}
.grid-filter {
  width: 100%;
  padding-bottom: var(--tem-space-2);
}
.table-elevation {
  box-shadow: var(--tem-shadow);
  border-radius: var(--tem-radius);
}
/*# sourceMappingURL=dynamic-forms.component.css.map */
